import { Box } from '@chakra-ui/react';
import { PageSpinner } from 'components/atoms/PageSpinner';
import { PageContext } from 'components/common/PageContext';
import { QueryErrorState } from 'components/common/QueryErrorState';
import { SessionPlanDisplay, SessionPlanFeedbackCard } from 'components/session-plan';
import { useSessionPlan } from 'hooks/api/backend/session-plan';
import { ReactElement } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ProtectedRoutes } from 'types/Routes';

export const SessionPlanDetailPage = (): ReactElement => {
  const { planId } = useParams<{ planId: string }>();
  const navigate = useNavigate();
  const { data: plan, isLoading, isError, error, refetch } = useSessionPlan(planId);

  const handleRetry = async (): Promise<void> => {
    try {
      await refetch();
    } catch {
      // QueryErrorState / global handlers cover this
    }
  };

  if (isLoading) {
    return (
      <PageContext
        title="Unterrichtsplanung"
        headTitle="Unterrichtsplanung"
        hasBackButton
        customOnBackClick={() => navigate(ProtectedRoutes.SESSION_PLAN)}
      >
        <PageSpinner />
      </PageContext>
    );
  }

  if (isError || !plan) {
    return (
      <PageContext
        title="Unterrichtsplanung"
        headTitle="Unterrichtsplanung"
        hasBackButton
        customOnBackClick={() => navigate(ProtectedRoutes.SESSION_PLAN)}
      >
        <QueryErrorState error={error ?? new Error('Plan not found')} onRetry={handleRetry} />
      </PageContext>
    );
  }

  return (
    <PageContext
      title={plan.title}
      headTitle={plan.title}
      hasBackButton
      customOnBackClick={() => navigate(ProtectedRoutes.SESSION_PLAN)}
    >
      <Box bg="background.canvas" minH="100%" px={{ base: 'm', md: 'l' }} py="l" maxW="960px">
        <SessionPlanDisplay plan={plan} />
        <SessionPlanFeedbackCard planId={plan.id} />
      </Box>
    </PageContext>
  );
};
